<template>
  <div class="games">
    <div id="head-page" class="globulo parallaxe">
      <div id="scene">
      </div>
    </div>

    <div class="grid-container content-page"> 
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-6 medium-offset-3 cell center">
          <title-page class="number" attrpage="401" baseline="Cette page demande un accès spécial">hop hop hop !</title-page>
          
          <div class="road-game gabarit">
            <div class="box-mascotte">
              <img src="@/assets/images/mascotte/mascotte-red.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>
              <div class="bubble left txtleft">Si tu veux accéder à cette page il faut surement te connecter...</br>Je te conseille de revenir sur tes pas pour <a href="/" title="" >se connecter.</a></div>
            </div> 
          </div>
          
        </div> 
      </div> 
    </div>    
  </div>    
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import GameItem from '@/components/GameItem'
  export default {
    components: { TitlePage, GameItem }
  }
</script>
